import { Helmet } from 'react-helmet';
import { Flex, Stack, Text, Divider, Link, Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

function Privacy() {

  const { t } = useTranslation();

  const changeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  return (
    <>
    {/* Canonical 태그 설정 */}
    <Helmet>
      <link rel="canonical" href="https://www.dodo-dot.com/privacy-policy" />
      <title>{t('Title')}</title>
    </Helmet>

    <Flex px={4} py={4}
          flex="1"
          bgColor="#ffffff">
    <Stack>
      <Button onClick={() => changeLanguage('en')}>English</Button>
      <Button onClick={() => changeLanguage('ko')}>한국어</Button>
      <Text px={4} py={8} fontWeight="bold" fontSize="xl">{t('Title')}</Text>
      <Text px={4} py={4} fontWeight="medium" fontSize="md">{t('TitleContent01')}</Text>
        {/* 이 개인정보 처리방침은 K-CookingTrip 애플리케이션(이하 "애플리케이션")에 적용되며, 이는 
        DodoDot(이하 "서비스 제공자")에서 개발한 모바일 기기용 무료 서비스로 제공됩니다. 이 서비스는 
        "있는 그대로(AS IS)" 제공됩니다. */}

      <Text px={4} py={2} fontWeight="medium" fontSize="md">{t('TitleContent02')}</Text>
      <Divider />

      <Text px={4} py={4} fontWeight="semibold" fontSize="md">{t("SubTitle01")}</Text>
      <Text px={6} fontWeight="semibold" fontSize="md">{t("SubSubTitle01")}</Text>
      <Text px={6}>{t("SubSubContent01")}</Text>
      <Text px={6}>{t("SubSubContent0101")}</Text>
      <Text px={6}>{t("SubSubContent0102")}</Text>

      <Text px={6} fontWeight="semibold" fontSize="md">{t("SubSubTitle02")}</Text>
      <Text px={6}>{t("SubSubContent02")}</Text>
      <Text py={2}></Text>

      <Divider />

      <Text px={4} py={4} fontWeight="semibold" fontSize="md">{t("SubTitle02")}</Text>
      <Text px={6}>{t("SubContent02")}</Text>
      <Text py={2}></Text>
      <Divider />

      <Text px={4} py={4} fontWeight="semibold" fontSize="md">{t("SubTitle03")}</Text>
      <Text px={6}>{t("SubContent03")}</Text>
      <Link variant="underline" href="https://unity.com/legal/privacy-policy">
       <Text px={6} fontWeight="bold">{t("SubSubContent03")}</Text>
      </Link>
      <Link variant="underline" href="https://firebase.google.com/support/privacy">
       <Text px={6} fontWeight="bold">{t("SubSubContent04")}</Text>
      </Link>
      <Text py={2}></Text>
      <Divider />

      {/* <Text px={4} py={4} fontWeight="semibold" fontSize="md">○ 옵트아웃 권리</Text>
      <Text px={6}>
      • 사용자는 애플리케이션을 삭제함으로써 정보 수집을 중단할 수 있습니다. 삭제는 사용자의 
        모바일 기기 또는 앱 스토어에서 제공하는 표준 삭제 절차를 통해 진행할 수 있습니다.
      </Text>
      <Text py={2}></Text>
      <Divider /> */}

      <Text px={4} py={4} fontWeight="semibold" fontSize="md">{t("SubTitle04")}</Text>
      <Text px={6}>{t("SubContent04")}</Text>
      <Text py={2}></Text>
      <Divider />

      <Text px={4} py={4} fontWeight="semibold" fontSize="md">{t("SubTitle05")}</Text>
      <Text px={6}>{t("SubContent05")}</Text>
      <Text py={2}></Text>
      <Divider />

      <Text px={4} py={4} fontWeight="semibold" fontSize="md">{t("SubTitle06")}</Text>
      <Text px={6}>{t("SubContent06")}</Text>
      <Text py={2}></Text>            
      <Divider />

      <Text px={4} py={4} fontWeight="semibold" fontSize="md">{t("SubTitle07")}</Text>
      <Text px={6}>{t("SubContent07")}</Text>
      <Text py={2}></Text>
      <Divider />

      <Text px={4} py={4} fontWeight="semibold" fontSize="md">{t("SubTitle08")}</Text>
      <Text px={6}>{t("SubContent08")}</Text>
      <Text py={2}></Text>
      <Divider />

      <Text px={4} py={4} fontWeight="semibold" fontSize="md">{t("SubTitle09")}</Text>
      <Text px={6}>{t("SubConten09")}</Text>
      <Text py={8}></Text>
      </Stack>
    </Flex>
    </>
  );
}


export default Privacy;
